import flatten from 'lodash/flatten';
import { get, toString } from 'lodash/fp';

import {
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  SET_FORM_FIELD,
  SET_FORM_FIELDS_IN_BULK
} from '../constants/actionTypes';
import { FORM_FIELDS, USER_SIGN_OUT } from '../constants/apiTypes';
import decodeFormFields from '../normalizers/decodeFormFields';
import decodeFormSection from '../normalizers/decodeFormSection';

const initialState = {
  fields: {},
  isLoading: false,
  name: '',
  sections: []
};

function formFieldsReducer(state = initialState, action) {
  switch (action.type) {
    case API_CALL_REQUEST:
      return action.api === FORM_FIELDS
        ? {
            ...initialState,
            isLoading: true
          }
        : state;

    case API_CALL_SUCCESS:
      if (action.api === FORM_FIELDS) {
        const sections = action.data.sections || [];
        const fields = flatten(sections.map(s => s.fields));
        const initialValues = action.initialValues || {};
        return {
          ...state,
          fields: decodeFormFields(fields, initialValues),
          isLoading: false,
          name: action.data.name,
          sections: sections.map(decodeFormSection)
        };
      }
      if (action.api === USER_SIGN_OUT) {
        return initialState;
      }
      break;

    case SET_FORM_FIELD:
      if (action.key === 'country_id') {
        const countryOptions = get('options', state.fields[action.key]) || [];
        const { states } = countryOptions.find(cty => cty.value === action.value);

        if (states) {
          const stateOptions = action.value
            ? states.map(opt => ({
                code: opt.code ? opt.code.toLowerCase() : '',
                label: opt.name,
                value: toString(opt.id),
                disabled: opt.active === 0
              }))
            : [];

          const { fields } = state;
          if (fields.state_id) {
            fields.state_id.options = stateOptions;
          }

          return {
            ...state,
            fields: {
              ...fields,
              [action.key]: {
                ...state.fields[action.key],
                key: action.key,
                value: action.value
              }
            }
          };
        }
      }

      return {
        ...state,
        fields: {
          ...state.fields,
          [action.key]: {
            ...state.fields[action.key],
            key: action.key,
            value: action.value
          }
        }
      };

    case SET_FORM_FIELDS_IN_BULK:
      return {
        ...state,
        fields: Object.entries(action.payload).reduce(
          (memo, [key, value]) => ({
            ...memo,
            [key]: {
              ...memo[key],
              key,
              value
            }
          }),
          state.fields
        )
      };

    default:
  }

  return state;
}

export default formFieldsReducer;
